import axios from '@/axios';

const RESOURCE_NAME = '/ecosystem/articles';

export default {

    getArticles(startupId) {
        return axios.get(`${RESOURCE_NAME}/get-articles?startup_id=${startupId}`)
    },

    save(id, startupId, data) {
        return axios.post(`${RESOURCE_NAME}/save?id=${id}&startup_id=${startupId}`, data)
    },
}
